import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class KidComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentKid | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.defaultValue = settings?.defaultValue;
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.kprefix = settings?.kprefix ?? 'K_NODE';
		this.input = true;
		this.options = {
			button: 'genKid',
			...settings?.options,
		};
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}
}
